import type { PrintResult, SaleVerdict } from '@krp/client-runtime'

import type { AgentSessionActions, Cashier } from '../../agent-session/model/agentSessionController'

/**
 * Команды кассе из диалога «Действия» (смена, наличные, X-отчёт) для РМК «Собственной» (RP-OWN11): каждая берёт кассира в момент
 * нажатия (с проверкой срока подтверждения) и несёт его `cashierId` агенту. Нет подтверждённого кассира — команда не уходит, а
 * возвращает причину текстом; правило допуска живёт здесь, а не в пороге агента.
 */

export type TillActions = Pick<AgentSessionActions, 'openShift' | 'closeShift' | 'cash' | 'printReportX'>

/** Команда не отправлена: нет подтверждённого кассира. */
export interface Blocked {
  blocked: string
}

export const isBlocked = (value: unknown): value is Blocked => typeof value === 'object' && value !== null && 'blocked' in value

const FALLBACK_REASON = 'Подтвердите кассира: выберите его и введите PIN.'

export function tillCommands(actions: TillActions, cashierNow: () => Cashier | null, reason: () => string | null) {
  const guard = <T>(call: (cashier: Cashier) => Promise<T>): Promise<T | Blocked> => {
    const cashier = cashierNow()
    return cashier === null ? Promise.resolve({ blocked: reason() ?? FALLBACK_REASON }) : call(cashier)
  }
  return {
    openShift: (): Promise<SaleVerdict | null | Blocked> => guard((cashier) => actions.openShift(cashier)),
    closeShift: (): Promise<SaleVerdict | null | Blocked> => guard((cashier) => actions.closeShift(cashier)),
    cash: (type: 'in' | 'out', amount: number): Promise<SaleVerdict | null | Blocked> => guard((cashier) => actions.cash(type, amount, cashier)),
    printReportX: (): Promise<PrintResult | null | Blocked> => guard((cashier) => actions.printReportX(cashier)),
  }
}
